<template>
<div>
  <el-dialog :append-to-body="true" :title="customTitle==''?title:customTitle" :close-on-click-modal="false"
    v-dialogDrag :visible.sync="visible" :before-close="close" width="1260px" hei>
    <el-form :model="inputForm" ref="inputForm" v-loading="loading" :class="method==='view'?'readonly':''"  :disabled="method==='view'"
             label-width="120px">
      <el-row>
        <el-descriptions title="" size="large" :column="2" border :contentStyle="CS" :label-style="LS">
          <el-descriptions-item label="上次操作人员">{{inputForm.actorName}}</el-descriptions-item>
          <el-descriptions-item label="操作时间">{{inputForm.startTime}}</el-descriptions-item>
          <el-descriptions-item label="事件分类">{{inputForm.category}}</el-descriptions-item>
          <el-descriptions-item label="事件名称">{{inputForm.categoryName}}</el-descriptions-item>
          <!-- <el-descriptions-item label="事件代码">{{inputForm.code}}</el-descriptions-item> -->
          <!-- <el-descriptions-item label="事件编号" :span="2">{{inputForm.code}}</el-descriptions-item> -->
          <!-- <template v-if="inputForm.code=='Project_Quality'" >
            <el-descriptions-item label="质量标准"  :span="2">
              {{inputForm.remarks}}
            </el-descriptions-item>
          </template> -->
          <!-- <el-descriptions-item label="序号"  :span="2">
            <el-input style="width: 100% !important;" @focus="allSelect($event)" v-model="inputForm.sort"></el-input>
          </el-descriptions-item> -->
          <el-descriptions-item  v-if="ifDescription" label="说明" :span="2" >
            <el-input v-model="inputForm.description" type="textarea" :autosize="{ minRows: 2, maxRows: 5 }"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="文件" :span="2">
            <template slot="label">
              <div class="tc" style="min-width:100px">文件<br>(可拖动上传)<br>(可粘贴上传截图)</div>
            </template>
            <file-upload
              ref="fileUploadRef"
              v-model="inputForm.filesIn"
              :max-height="400"
              :max-width="360"
              :root-path="inputForm.fileStorePath"
              :folder-name="inputForm.ownerCode"
              :ifSetUploadName="ifSetUploadName"
              :updateParams="{
                fileName: uploadInfo.fileName,
                tip: uploadInfo.tip,
                code: uploadInfo.type
              }"
              watermark=""
              :owner="ownerImg"
              :read-only="method=='view'"
              :visible="visible"
              :limit="1"
            ></file-upload>
          </el-descriptions-item>
        </el-descriptions>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close" icon="el-icon-close" type="danger">关闭</el-button>
      <el-button type="success" v-if="method != 'view'" @click="doSubmit()" v-noMoreClick icon="el-icon-check">确定</el-button>
    </span>
  </el-dialog>
</div>
</template>

<script>
  import FileUpload from '@/components/file/projectFileUpload.vue'
  // import StringUtil from './StringUtil'
  import dayjs from 'dayjs'
  export default {
    props: {
      fileStorePath: {
        type: String,
        default: ''
      },
      customTitle: {
        type: String,
        default: ''
      },
      ifDescription: {
        type: Boolean,
        default: true
      },
      ifSetUploadName: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        title: '',
        method: '',
        visible: false,
        loading: false,
        inputForm: {
          fileStorePath: '',
          id: '',
          ownerId: '',
          ownerName: '',
          ownerCode: '',
          ownerType: '',
          sort: 1,
          startTime: '',
          endTime: '',
          actorId: '',
          actorName: '',
          code: '',
          name: '',
          categoryName: '',
          category: '',
          data: '',
          result: '',
          description: '',
          filesIn: '',
          refBillId: '',
          refBillType: '',
          refBillCode: '',
          refItemId: '',
          refItemCode: '',
          refProjectCode: '',
          refContractCode: '',
          tags: '',
          remarks: '',
          createDate: ''
        },
        CS: {
          // 'text-align': 'center',  // 文本居中
          'min-width': '250px!important',   // 最小宽度
          'word-break': 'break-all'  // 过长时自动换行
        },
        LS: {
          // 'color': '#000',
          'text-align': 'center'
          // 'font-weight': '600',
          // 'height': '40px',
          // 'background-color': 'rgba(255, 97, 2, 0.1)',
          // 'min-width': '110px',
          // 'word-break': 'keep-all'
        },
        tagsList: [],
        tagsArr: [],
        ownerImg: [],
        uploadInfo: {
          fileName: '',
          tip: '',
          code: ''
        }
      }
    },
    components: {
      FileUpload
    },
    methods: {
      allSelect (e) {
        e.currentTarget.select()
      },
      close () {
        // if (this.method === 'add') {
        //   // 删除新增的数据
        //   this.$emit('canceladd', this.inputForm.id)
        //   this.$refs.inputForm.resetFields()
        //   this.visible = false
        //   this.$nextTick(() => {
        //     // 要先 visible = true 再操作ownerImg，不然图片不显示
        //     this.ownerImg = '1212' + new Date().getTime()
        //     this.inputForm.filesIn = ''
        //     // console.log(this.ownerImg)
        //   })
        // } else {
        //   this.$emit('refreshDataList')
        //   this.visible = false
        //   this.$nextTick(() => {
        //     // 要先 visible = true 再操作ownerImg，不然图片不显示
        //     this.ownerImg = '1212' + new Date().getTime()
        //     this.inputForm.filesIn = ''
        //     // console.log(this.ownerImg)
        //   })
        // }
        this.visible = false
      },
      init (method, id, data, uploadInfo) {
        this.method = method
        this.inputForm.id = id
        this.inputForm.ownerId = ''
        this.uploadInfo = uploadInfo
        if (method === 'add') {
          this.title = `新建` + uploadInfo.title
        } else if (method === 'edit') {
          this.title = '修改' + uploadInfo.title
        } else if (method === 'view') {
          this.title = '查看' + uploadInfo.title
        }
        this.visible = true
        this.loading = false
        this.$nextTick(() => {
          this.$refs.inputForm.resetFields()
          if (method === 'edit' || method === 'view') { // 修改或者查看
            this.loading = true
            // this.$http({
            //   url: `/unmfile/cecUnmFile/list`,
            //   method: 'get',
            //   params: {
            //     current: 1,
            //     size: 100,
            //     ownerId: id,
            //     category: id ? 'portfolio_gallery' : '',
            //     orders: [{ column: 'sort', asc: true }]
            //   }
            // }).then(({data}) => {
              // console.log(data)
              // if (data.records.length > 0) {
              //   this.inputForm = this.recover(this.inputForm, data.records[0])
              //   console.log(this.inputForm, data.records)
              //   this.$nextTick(() => {
              //     // 要先 visible = true 再操作ownerImg，不然图片不显示
              //     this.ownerImg = data.records
              //   })
              // }
              // this.loading = false
            // })
            if (data.length > 0) {
              this.inputForm = this.recover(this.inputForm, this.findLatestStartTimeObject(data, 'startTime'))
            }
            this.$nextTick(() => {
              // 要先 visible = true 再操作ownerImg，不然图片不显示
              this.ownerImg = data
            })
            this.loading = false
          }
        })
      },
      // 遍历最晚时间列
      findLatestStartTimeObject (arr, objName) {
        let latestObject = null
        // 遍历数组对象
        for (let i = 0; i < arr.length; i++) {
          const currentObject = arr[i]
          // 确保当前对象有'startTime'属性
          if (currentObject[objName]) {
            // 将'startTime'字符串转换为日期对象
            const currentTime = new Date(currentObject[objName])
            // 如果这是第一个对象，或者当前对象的'startTime'比已知的最晚时间更晚
            if (!latestObject || new Date(latestObject[objName]) < currentTime) {
              // 更新最晚时间的对象
              latestObject = currentObject
            }
          }
        }
        return latestObject
      },
      // initByOwnerId (method, ownerId) {
      //   this.method = method
      //   this.inputForm.ownerId = ownerId
      //   if (method === 'add') {
      //     this.title = `新建`
      //   } else if (method === 'edit') {
      //     this.title = '修改'
      //   } else if (method === 'view') {
      //     this.title = '查看'
      //   }
      //   this.visible = true
      //   this.loading = false
      //   this.$nextTick(() => {
      //     this.$refs.inputForm.resetFields()
      //     if (method === 'edit' || method === 'view') { // 修改或者查看
      //       this.loading = true
      //       this.$http({
      //         url: `/cec/property/management/activity/activity/getLastRecordByOwnerId?ownerId=${this.inputForm.ownerId}`,
      //         method: 'get'
      //       }).then(({data}) => {
      //         this.inputForm = this.recover(this.inputForm, data.activity)
      //         this.loading = false
      //       })
      //     }
      //   })
      // },

      createNewRecordForOwnerId (uploadInfo) {
        // this.inputForm.code = eventCode
        this.inputForm.ownerId = ''
        this.method = 'add'
        this.title = `新增` + uploadInfo.title
        this.visible = true
        this.loading = false
        let userObj = JSON.parse(localStorage.getItem('user'))
        this.inputForm.actorId = userObj.id
        this.inputForm.actorName = userObj.name
        this.inputForm.startTime = dayjs().format('YYYY-MM-DD hh:mm:ss')
        this.inputForm.category = uploadInfo.category + '_' + uploadInfo.type
        this.inputForm.categoryName = uploadInfo.categoryName + uploadInfo.title
        this.uploadInfo = uploadInfo
        this.$nextTick(() => {
          this.$refs.inputForm.resetFields()
          this.loading = true
          // this.$http({
          //   url: `/unmfile/cecUnmFile/list`,
          //   method: 'get',
          //   params: {
          //     current: 1,
          //     size: 100,
          //     ownerId: ownerId,
          //     category: ownerId ? 'portfolio_gallery' : ''
          //   }
          // }).then(({data}) => {
          //   console.log(data)
          //   if (data.records.length > 0) {
          //     this.inputForm = this.recover(this.inputForm, data.records[0])
          //     console.log(this.inputForm, data.records)
          //     this.$nextTick(() => {
          //       // 要先 visible = true 再操作ownerImg，不然图片不显示
          this.ownerImg = []
          //     })
          //   }
          this.loading = false
          // })
        })
      },
      getFileExtension (fileName, type) {
      // 使用 lastIndexOf 方法找到最后一个点的位置
        let lastDotIndex = fileName.lastIndexOf('.')
        // 如果没有找到点，返回空字符串或适当的默认值
        if (lastDotIndex === -1) return ''
        // 截取从点到字符串末尾的部分作为扩展名
        let extension = ''
        if (type === 'subEnd') {
          extension = fileName.substring(lastDotIndex)
        } else {
          extension = fileName.substring(0, lastDotIndex)
        }
        return extension
      },
      // 表单提交
      doSubmit () {
        let fileGalleryList = []
        let fileList = JSON.parse(JSON.stringify(this.$refs.fileUploadRef.fileList))
        if (this.method === 'add') {
          fileGalleryList = fileList.map(item => {
            let citem = {
              fileName: item.fileName,
              filePath: item.filePath,
              fileSize: item.fileSize,
              actorId: this.inputForm.actorId,
              actorName: this.inputForm.actorName,
              startTime: this.inputForm.startTime,
              categoryName: this.inputForm.categoryName,
              description: this.inputForm.description,
              category: this.inputForm.category,
              name: this.getFileExtension(item.fileName, ''),
              url: item.filePath,
              createDate: item.createDate,
              pixel: item.pixel
            }
            return citem
          })
        } else {
          let userObj = JSON.parse(localStorage.getItem('user'))
          fileGalleryList = fileList.map(item => {
            if (this.ifDescription) {
              item.description = this.inputForm.description
            }
            if (item.type === 'new') {
              item.id = ''
              item.actorId = userObj.id
              item.actorName = userObj.name
              item.categoryName = this.inputForm.categoryName
              item.description = this.ifDescription ? this.inputForm.description : ''
              item.category = this.inputForm.category
              item.startTime = dayjs().format('YYYY-MM-DD hh:mm:ss')
            }
            return item
          })
        }
        this.$emit('doSubmitList', fileGalleryList)
        this.visible = false
      }
    }
  }
</script>
